<template>
  <div
    class="guide-banner"
    @click="callMarketByPkg()">
    <div class="yoli-icon"/>
    <div class="yoli-title">一键播放更多精彩</div>
    <div class="yoli-btn">打开看看</div>
  </div>
</template>

<script>
import yoliBanner from '@oppobrowser/lib-browser-yoliBanner';
const { isApkInstall, clickCallback } = yoliBanner;

export default {
  created() {},

  props: {
    isShowTip: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    callMarketByPkg: function() {
      if (this.isShowTip) {
        this.$emit('show');
        return;
      }

      if (isApkInstall()) {
        window.oa('send', {
          hitType: 'event',
          eventCategory: 'app_go',
          eventAction: 'click',
          eventLabel: 'oppo',
          eventValue: '',
        });
      }
      clickCallback();
    },
  },
};
</script>

<style lang='scss' scoped>
.guide-banner {
  height: px2rem(178);
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 1003;
  box-sizing: border-box;
  padding: 0 px2rem(40);
  display: flex;
  align-items: center;
  border: px2rem(3) solid #e3e3e3;
  .yoli-icon {
    flex: px2rem(118) 0 0;
    background: url('../common/img/yoli.png') no-repeat 0 0 / px2rem(118)
      px2rem(118);
    width: px2rem(118);
    height: px2rem(118);
  }
  .yoli-title {
    font-size: px2rem(48);
    color: #de385f;
    font-weight: 900;
    flex: 1;
    padding-left: px2rem(14);
  }
  .yoli-title {
    font-size: px2rem(48);
    color: #de385f;
    font-weight: 900;
    flex: 1;
    padding-left: px2rem(14);
  }
  .yoli-btn {
    width: px2rem(234);
    height: px2rem(78);
    background: #fd3458;
    border-radius: px2rem(15);
    font-size: px2rem(34);
    color: #fff;
    text-align: center;
    line-height: px2rem(80);
  }
}
</style>
